<ion-header class="ion-no-border favorite-modal-header">
  <ion-toolbar class="favorite-modal-toolbar">
    <ion-title>
      <div class="favorite-header-title">
        <span>Edit Favorites</span>
        <ion-badge class="favorite-count-badge" *ngIf="items.length > 0">{{ items.length }}</ion-badge>
      </div>
    </ion-title>

    <ion-buttons slot="end">
      <ion-button color="primary" class="favorite-close-button" (click)="cancel()" aria-label="Close">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar class="favorite-search-toolbar" *ngIf="items.length > 3">
    <ion-searchbar
      [(ngModel)]="searchTerm"
      placeholder="Search favorites..."
      show-clear-button="focus"
      class="favorite-searchbar"
      aria-label="Search favorites">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content class="favorite-modal-content">
  <div class="favorite-modal-shell">

    <!-- Reorder & edit hint banner -->
    <div class="favorite-hint-pill" *ngIf="items.length > 1 && !searchTerm">
      <ion-icon name="swap-vertical-outline" aria-hidden="true"></ion-icon>
      <span>Drag handle to reorder &bull; Tap pencil to rename</span>
    </div>

    <!-- Favorites card list -->
    <ion-list lines="none" class="favorite-cards-list" *ngIf="filteredItems.length > 0">
      <ion-reorder-group (ionItemReorder)="doReorder($event)" [disabled]="isAnyEditing() || searchTerm.length > 0">
        <ion-item
          *ngFor="let item of filteredItems; let i = index"
          class="favorite-card-item"
          [class.favorite-row-editing]="item.isEditing"
          lines="none"
          detail="false">

          <!-- Reorder handle -->
          <ion-reorder slot="start" *ngIf="!item.isEditing && !searchTerm" class="favorite-reorder-handle">
            <ion-icon name="reorder-two-outline" class="reorder-grip-icon" aria-hidden="true"></ion-icon>
          </ion-reorder>

          <!-- Type / Route Icon Badge -->
          <div class="favorite-icon-wrap" [ngClass]="getFavoriteIconClass(item)" slot="start" *ngIf="!item.isEditing">
            <ion-icon [name]="getFavoriteIconName(item)" aria-hidden="true"></ion-icon>
          </div>

          <!-- Label / Path info -->
          <ion-label class="favorite-text-content" *ngIf="!item.isEditing">
            <div class="favorite-title">{{ displayName(item) }}</div>
            <div class="favorite-path-hint" *ngIf="displayPath(item)">{{ displayPath(item) }}</div>
          </ion-label>

          <!-- Inline Edit Input -->
          <ion-input
            *ngIf="item.isEditing"
            [(ngModel)]="item.editName"
            class="favorite-edit-input"
            label="Favorite name"
            labelPlacement="floating"
            fill="outline"
            [clearInput]="true"
            (keyup.enter)="saveEdit(item)"
            (keyup.escape)="cancelEdit(item)">
          </ion-input>

          <!-- View Action Buttons -->
          <ion-buttons slot="end" class="favorite-item-actions" *ngIf="!item.isEditing">
            <ion-button
              fill="clear"
              class="favorite-action-btn favorite-action-btn--edit"
              aria-label="Edit favorite"
              (click)="beginEdit(item)">
              <ion-icon name="create-outline" slot="icon-only"></ion-icon>
            </ion-button>

            <ion-button
              fill="clear"
              color="danger"
              class="favorite-action-btn favorite-action-btn--delete"
              aria-label="Delete favorite"
              (click)="deleteItem(findItemIndex(item))">
              <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>

          <!-- Edit Action Buttons -->
          <div *ngIf="item.isEditing" slot="end" class="favorite-edit-actions">
            <ion-button fill="solid" color="primary" class="favorite-edit-action-btn favorite-edit-action-btn--save" aria-label="Save favorite" (click)="saveEdit(item)">
              <ion-icon name="checkmark-outline" aria-hidden="true"></ion-icon>
              <span class="favorite-action-label">Save</span>
            </ion-button>

            <ion-button fill="clear" color="medium" class="favorite-edit-action-btn favorite-edit-action-btn--cancel" aria-label="Cancel edit" (click)="cancelEdit(item)">
              <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
              <span class="favorite-action-label">Cancel</span>
            </ion-button>
          </div>

        </ion-item>
      </ion-reorder-group>
    </ion-list>

    <!-- Empty State: No favorites -->
    <div class="favorite-empty-state" *ngIf="items.length === 0">
      <div class="favorite-empty-icon-wrap">
        <ion-icon name="star-outline" aria-hidden="true"></ion-icon>
      </div>
      <h3 class="favorite-empty-title">No Favorites Yet</h3>
      <p class="favorite-empty-desc">
        Bookmark frequently visited pages, cameras, and gate overviews using the star icon in page headers.
      </p>
    </div>

    <!-- Empty State: No search results -->
    <div class="favorite-empty-state" *ngIf="items.length > 0 && filteredItems.length === 0">
      <div class="favorite-empty-icon-wrap">
        <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
      </div>
      <h3 class="favorite-empty-title">No Matches Found</h3>
      <p class="favorite-empty-desc">
        No favorites match "{{ searchTerm }}".
      </p>
    </div>

  </div>
</ion-content>
